import React, { useEffect, useState } from "react";
import PageHeader from "../pages/PageHeader";
import projectList from "../assets/projectList";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Project = () => {
  
  const [activeCategory, setActiveCategory] = useState("All");
const [hoveredCard, setHoveredCard] = useState(null);
  // Extract unique categories from projectList
  const categories = ["All", ...new Set(projectList.map((portfolio) => portfolio.category))];

  // Filter projects based on active category
  const filteredProjects =
    activeCategory === "All"
      ? projectList
      : projectList.filter((portfolio) => portfolio.category === activeCategory);

      useEffect(() => {
    window.scrollTo(0, 0); // This will move the user to the top of the page
  }, []);
  return (
    <div>
<Helmet>
  <title>Portfolio Grid | Appnexts – Web, App, and Digital Solutions Portfolio</title>
  <meta
    name="description"
    content="Explore our diverse portfolio of projects including website development, mobile apps, SEO campaigns, data scraping tools, and more. See what Appnexts has delivered."
  />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.appnexts.com/portfolio-grid" />

  {/* Open Graph Meta Tags */}
  <meta property="og:title" content="Portfolio Grid | Appnexts" />
  <meta property="og:description" content="Browse real-world examples of our work in web development, mobile apps, SEO, and design. See how Appnexts helps businesses succeed online." />
  <meta property="og:image" content="https://www.appnexts.com/seo_image/our_projects_seo.png" />
  <meta property="og:url" content="https://www.appnexts.com/portfolio-grid" />
  <meta property="og:type" content="website" />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Our Projects | Appnexts Portfolio" />
  <meta name="twitter:description" content="Check out our successful web and app development projects, SEO work, and creative design solutions." />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/our_projects_seo.png" />

  {/* JSON-LD Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Portfolio Grid - Appnexts",
      "description": "A portfolio collection showcasing completed projects by Appnexts in web development, mobile apps, SEO, and more.",
      "url": "https://www.appnexts.com/portfolio-grid",
        "publisher": {
        "@type": "Organization",
        "name": "AppNexts",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.appnexts.com/seo_image/appnexts.png"
        }
      },
      "image": "https://www.appnexts.com/seo_image/our_projects_seo.png"
    })}
  </script>
</Helmet>


      
      <PageHeader title="Portfolio Grid" breadcrumb={[{ label: "Home", path: "/" },{ label: "Portfolio Grid" }]}/>

      <div className="container mx-auto px-4 py-6">
        {/* Dynamic Category Navigation */}
        <nav className="flex flex-wrap justify-center gap-4">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                activeCategory === category
                  ? "bg-[#304f7c] text-white border-2 border-[#304f7c]"
                  : "bg-gray-100"
              }`}
              aria-current={activeCategory === category ? "page" : undefined}
            >
              {category}
            </button>
          ))}
        </nav>

        {/* Projects Grid */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          {filteredProjects.map((portfolio) => (
            <div
            key={portfolio.id}
            className="my-6"
            onMouseEnter={() => setHoveredCard(portfolio.id)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <Link to={`/portfolio-grid/${portfolio.id}`}>
            <div className="flex flex-col gap-2 shadow-lg mx-6 rounded-3xl relative bg-[#f7f8fd] overflow-hidden">
              <img
                src={portfolio.image}
                alt={portfolio.title}
                loading="lazy"
                className="w-full object-cover rounded-t-3xl"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="bg-white rounded-md shadow-md relative overflow-hidden">
                  <div
                    className="w-1 bg-blue-800 absolute left-0 transition-all duration-300"
                    style={{
                      height: hoveredCard === portfolio.id ? "100%" : "24px",
                      top: hoveredCard === portfolio.id ? "0" : "calc(50% - 12px)",
                    }}
                  />
                  <div className="p-6 pl-8">
                    <p className="text-[#504e9a] font-semibold mb-1">{portfolio.category}</p>
                    <h3 className="text-2xl font-bold text-gray-900">{portfolio.title}</h3>
                  </div>
                </div>
              </div>
            </div>
            </Link>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Project;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import PageHeader from "../pages/PageHeader";
// import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet";

// const API_BASE = "https://apis.appnexts.com";

// const Project = () => {
//   const [activeCategory, setActiveCategory] = useState("All");
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [catRes, projRes] = await Promise.all([
//           axios.get(`${API_BASE}/api/categories`),
//           axios.get(`${API_BASE}/api/projects`),
//         ]);
//         setCategories(catRes.data); // Expecting each item: { _id, categoryName, subcategories }
//         setProjects(projRes.data);   // Expecting array of projects
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load projects or categories.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//     window.scrollTo(0, 0);
//   }, []);

//   const filteredProjects =
//     activeCategory === "All"
//       ? projects
//       : projects.filter((p) => {
//           const cat = categories.find((c) => c._id === p.categoryId);
//           return cat?.categoryName === activeCategory;
//         });

//   if (loading) return <p className="pt-20 text-center">Loading...</p>;
//   if (error) return <p className="pt-20 text-center text-red-600">{error}</p>;

//   return (
//     <div>
//       <Helmet>
//         <title>Portfolio Grid | Appnexts</title>
//         <meta
//           name="description"
//           content="Explore our diverse portfolio of projects..."
//         />
//       </Helmet>

//       <PageHeader
//         title="Portfolio Grid"
//         breadcrumb={[{ label: "Home", path: "/" }, { label: "Portfolio Grid" }]}
//       />

//       <div className="container mx-auto px-4 py-6">
//         <nav className="flex flex-wrap justify-center gap-4">
//           <button
//             onClick={() => setActiveCategory("All")}
//             className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
//               activeCategory === "All"
//                 ? "bg-[#304f7c] text-white border-2 border-[#304f7c]"
//                 : "bg-gray-100"
//             }`}
//           >
//             All
//           </button>
//           {categories.map((cat) => (
//             <button
//               key={cat._id}
//               onClick={() => setActiveCategory(cat.categoryName)}
//               className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
//                 activeCategory === cat.categoryName
//                   ? "bg-[#304f7c] text-white border-2 border-[#304f7c]"
//                   : "bg-gray-100"
//               }`}
//             >
//               {cat.categoryName}
//             </button>
//           ))}
//         </nav>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
//           {filteredProjects.map((p) => {
//             const cat = categories.find((c) => c._id === p.categoryId);
//             return (
//               <div
//                 key={p._id}
//                 className="my-6"
//                 onMouseEnter={() => setHoveredCard(p._id)}
//                 onMouseLeave={() => setHoveredCard(null)}
//               >
//                 <Link to={`/portfolio-grid/${p._id}`}>
//                   <div className="flex flex-col gap-2 shadow-lg mx-6 rounded-3xl relative bg-[#f7f8fd] overflow-hidden">
//                     {p.images?.[0] && (
//                       <img
//                         src={p.images[0]}
//                         alt={p.name}
//                         loading="lazy"
//                         className="w-full object-cover rounded-t-3xl"
//                       />
//                     )}
//                     <div className="absolute bottom-0 left-0 right-0 p-6">
//                       <div className="bg-white rounded-md shadow-md relative overflow-hidden">
//                         <div
//                           className="w-1 bg-blue-800 absolute left-0 transition-all duration-300"
//                           style={{
//                             height:
//                               hoveredCard === p._id ? "100%" : "24px",
//                             top:
//                               hoveredCard === p._id
//                                 ? "0"
//                                 : "calc(50% - 12px)",
//                           }}
//                         />
//                         <div className="p-6 pl-8">
//                           <p className="text-[#504e9a] font-semibold mb-1">
//                             {cat?.categoryName || "Unknown"}
//                           </p>
//                           <h3 className="text-2xl font-bold text-gray-900">
//                             {p.name}
//                           </h3>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </Link>
//               </div>
//             );
//           })}
//           {!filteredProjects.length && (
//             <p className="col-span-full text-center py-8">
//               🛠️ No projects found in "{activeCategory}"
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Project;


